import { render, staticRenderFns } from "./TumorConference.vue?vue&type=template&id=6a9fc787&"
import script from "./TumorConference.vue?vue&type=script&lang=js&"
export * from "./TumorConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports